export const permissionaryInitialValues = {
  cdTipoRelatorioLinhas: 6,
  boExibirPendencias: true,
  polos: [],
  localidades: [],
  linhas: [],
  permissionarios: [],
  dtVencimento: { dtInicio: '', dtFim: '' },
  dtVigencia: { dtInicio: '', dtFim: '' },
  nuTermo: '',
  nuCepe: '',
  anoCepe: '',
  dePlaca: '',
  tiposVeiculo: [],
  situacaoPermissionario: 1,
  situacaoLinha: 1
};
